import { CAT_NECESSARY, CAT_ANALYTICS } from "../constants.js";

const translation = {
  consentModal: {
    title: "Avis sur les témoins de connexion",
    description:
      "Nous utilisons des témoins de connexion essentiels pour garantir le bon fonctionnement de ce site Web. Nous utilisons également des témoins de connexion de suivi optionnels pour nous aider à comprendre comment vous interagissez avec notre site. Ces témoins optionnels ne seront définis qu’avec votre consentement.",
    acceptAllBtn: "Tout accepter",
    acceptNecessaryBtn: "Tout refuser",
    showPreferencesBtn: "Gérer les préférences individuelles",
  },
  preferencesModal: {
    title: "Gérer les préférences des témoins de connexion",
    acceptAllBtn: "Tout accepter",
    acceptNecessaryBtn: "Tout refuser",
    savePreferencesBtn: "Accepter la sélection actuelle",
    closeIconLabel: "Fermer la fenêtre",
    sections: [
      {
        title: "Utilisation des témoins de connexion",
        description:
          "Nous utilisons des témoins de connexion pour assurer les fonctions essentielles de ce site Web et améliorer votre expérience de navigation.",
      },
      {
        title: "Témoins de connexion strictement nécessaires",
        description:
          "Ces témoins de connexion sont essentiels au bon fonctionnement du site Web, par exemple pour l’authentification des utilisateurs.",
        linkedCategory: CAT_NECESSARY,
        cookieTable: {
          headers: {
            name: "Nom",
            domain: "Service",
            description: "Description",
            expiration: "Expiration",
          },
          body: [
            {
              name: "_care_leavers_social_hub_session",
              domain: "www.secure-messaging.co.uk",
              description:
                "Témoin de connexion défini par la plateforme communautaire numérique pour l’authentification des utilisateurs.",
              expiration: "Session",
            },
            {
              name: "CSRF-TOKEN",
              domain: "www.secure-messaging.co.uk",
              description:
                "Témoin de connexion défini par la plateforme communautaire numérique pour l’authentification des utilisateurs",
              expiration: "Session",
            },
            {
              name: "__cf_bm",
              domain: ".www.secure-messaging.co.uk",
              description:
                "Ce témoin de connexion est utilisé pour distinguer les humains des robots afin de protéger le site Web contre les abus automatisés. Aucune donnée personnelle n’est collectée.",
              expiration: "30 minutes",
            },
          ],
        },
      },
      {
        title: "Analyse",
        description:
          "Les témoins de connexion utilisés pour l’analyse permettent de collecter des données qui aident les services à comprendre comment les utilisateurs interagissent avec un service particulier. Ces informations permettent d’améliorer le contenu et de créer de meilleures fonctionnalités qui améliorent l’expérience utilisateur.",
        linkedCategory: CAT_ANALYTICS,
        cookieTable: {
          headers: {
            name: "Nom",
            domain: "Service",
            description: "Description",
            expiration: "Expiration",
          },
          body: [
            {
              name: "_ga",
              domain: "Google Analytics",
              description:
                'Témoin de connexion défini par <a href="https://business.safety.google/adscookies/">Google Analytics</a>',
              expiration: "Expire après 12 jours",
            },
            {
              name: "_gid",
              domain: "Google Analytics",
              description:
                'Témoin de connexion défini par <a href="https://business.safety.google/adscookies/">Google Analytics</a>',
              expiration: "Session",
            },
          ],
        },
      },
    ],
  },
};

const servicesLabel =
  "Permet le stockage lié aux analyses, par exemple la durée de la visite.";

export { translation, servicesLabel };
